import {
  FETCHSYSLOGS,
  FETCHSYSLOGS_SUCCESS
} from "constants/ActionTypes";

export const fetchSysLogs = (start, end) => {
  return {
    type: FETCHSYSLOGS,
    payload: {
      start: start,
      end: end
    }
  };
};

export const fetchSysLogsSuccess = (sysLogs) => {
  return {
    type: FETCHSYSLOGS_SUCCESS,
    payload: sysLogs
  };
};
